import { type RefObject, useEffect } from "react";

import { queryClient } from "../../lib/queryClient";
import { getSupabase } from "../../lib/supabase";

const POLL_INTERVAL_MS = 30_000;

export function usePolling(cellsRef: RefObject<string[]>, unhealthy: boolean): void {
  useEffect(() => {
    if (!unhealthy) return;

    async function poll() {
      const current = cellsRef.current ?? [];
      if (!current.length) return;
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- hand-written RPC absent from generated DB types
        const { error } = await (getSupabase() as any).rpc("stations_nearby", { p_cells: current });
        if (error) {
          console.warn("[usePolling] RPC failed", { code: error.code, message: error.message });
          return;
        }
        queryClient.invalidateQueries({ queryKey: ["stations"] });
      } catch (err) {
        console.warn("[usePolling] poll threw unexpectedly", err);
      }
    }

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [unhealthy, cellsRef]);
}
